import { memo, useMemo } from 'react';

import { eachDayInTimeZone, getVisibleRange } from '../../utils/dateGrid';
import TimeGrid from '../TimeGrid';

import type { WeekViewProps } from './types';

function WeekView({ date, timeZone, ...rest }: WeekViewProps) {
  const days = useMemo(() => {
    const { start, end } = getVisibleRange(date, 'week', timeZone);
    return eachDayInTimeZone(start, end, timeZone);
  }, [date, timeZone]);

  return <TimeGrid days={days} timeZone={timeZone} {...rest} />;
}

export default memo(WeekView);
